module.exports = __webpack_public_path__ + "static/media/YB5F03_2.10c31a05.jpg";